import { Component, Input, Output, EventEmitter, CUSTOM_ELEMENTS_SCHEMA, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface MetricItem {
  key?: string;
  label: string;
  value: string | number;
  icon: string;
  variant?: 'primary' | 'success' | 'warning' | 'danger';
  clickable?: boolean;
}

@Component({
  selector: 'app-metrics',
  standalone: true,
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './app-metrics.html',
  styleUrls: ['./app-metrics.css']
})
export class AppMetrics {
  @Input() items: MetricItem[] = [];
  @Output() metricClick = new EventEmitter<string>();

  showMobileMenu = false;

  @HostListener('document:click')
  clickout() {
    this.showMobileMenu = false;
  }

  getVariantClasses(item: MetricItem): string {
    const base = 'px-3 py-2 bg-surface/30 backdrop-blur-md border border-white/5 rounded-2xl flex items-center gap-3 transition-all';
    const clickClass = item.clickable ? 'cursor-pointer hover:bg-surface/40 hover:scale-[1.02]' : 'cursor-default';
    
    return `${base} ${clickClass}`;
  }

  getIconClasses(variant?: string): string {
    const base = 'w-8 h-8 rounded-lg flex items-center justify-center border transition-all';
    
    switch (variant) {
      case 'success':
        return `${base} bg-emerald-500/10 text-emerald-500 border-emerald-500/20 group-hover:bg-emerald-500 group-hover:text-white`;
      case 'warning':
        return `${base} bg-amber-500/10 text-amber-500 border-amber-500/20 group-hover:bg-amber-500 group-hover:text-white`;
      case 'danger':
        return `${base} bg-red-500/10 text-red-500 border-red-500/20 group-hover:bg-red-500 group-hover:text-white`;
      case 'primary':
      default:
        return `${base} bg-primary/10 text-primary border-primary/20 group-hover:bg-primary group-hover:text-white`;
    }
  }

  onItemClick(item: MetricItem) {
    if (item.clickable && item.key) {
      this.metricClick.emit(item.key);
      this.showMobileMenu = false;
    }
  }
}
